<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
  viewBox="0 0 4197 4197"
   xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Vrstva_x0020_1">
    <circle class="fil0" cx="2098" cy="2098" r="2098"/>
    <g id="_805756808">
     <path class="fil1" d="M2820 2050c-103,-85 -201,-132 -290,-207 -56,-48 -143,-252 -178,-323 -182,-368 -336,-186 -575,10 -130,106 -212,138 -240,264 -16,70 -86,354 -68,405 28,79 121,65 157,18 30,-41 42,-144 54,-198 20,-87 15,-233 180,-294 -242,874 -32,669 -455,1360 -84,137 -21,283 138,242 78,-20 154,-186 198,-258 218,-362 174,-254 263,-641 34,36 78,72 113,112 226,263 174,161 232,471 25,130 32,297 147,324 74,17 126,-29 149,-68 32,-56 13,-124 2,-181 -28,-132 -48,-265 -77,-394 -17,-71 -49,-111 -85,-151 -68,-75 -301,-317 -295,-397 5,-53 71,-319 91,-355 90,179 71,154 224,263 194,138 187,155 304,109l11 -111z"/>
     <path class="fil1" d="M645 2891l149 -80c-18,-86 -90,-205 -120,-317 -167,-616 81,-921 119,-1109l-146 -86c-275,581 -276,1013 -2,1592z"/>
     <path class="fil1" d="M3391 1385c169,343 224,721 119,1109 -29,108 -105,240 -120,317l149 80c268,-523 267,-1066 -2,-1592l-146 86z"/>
     <path class="fil1" d="M3077 2621c1,1 28,16 32,19 21,11 43,22 64,34 152,-154 188,-642 112,-914 -22,-78 -49,-158 -96,-223l-154 49c37,237 251,361 -2,1005l44 30z"/>
     <path class="fil1" d="M1012 2675l136 -71c-12,-71 -55,-139 -78,-222 -25,-88 -36,-182 -37,-277 -3,-225 49,-324 118,-503l-139 -82 -63 104c-124,292 -128,727 20,992l43 59z"/>
     <path class="fil1" d="M2106 880c-60,27 -89,33 -115,95 -24,58 -24,117 6,177 40,81 149,151 268,96 227,-105 86,-484 -159,-368z"/>
    </g>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'Pir',
};
</script>

<style scoped>
.fil1 {fill:#FEFEFE}
      .fil0 {fill:#56D6D1}
</style>
